import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import { assignSalon, fetchAgentSalons } from "@/lib/bf";
import { fetchUsers } from "@/lib/api";

const nm = (a) => a.name || a.email;

export default function BFSalonMove() {
  const [agents, setAgents] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [rows, setRows] = useState(null);
  const [sel, setSel] = useState([]);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { fetchUsers().then((d) => setAgents(d.users.filter((u) => (u.role === "agent" || u.role === "admin") && u.share_slug))).catch(() => {}); }, []);
  useEffect(() => { setRows(null); setSel([]); fetchAgentSalons(from).then(setRows).catch(() => setRows([])); }, [from]);
  const shown = (rows || []).filter((r) => !q.trim() || [r.salon, r.admin_name, r.city, r.phone].join(" ").toLowerCase().includes(q.trim().toLowerCase()));
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const allOn = shown.length > 0 && shown.every((r) => sel.includes(r.id));
  const move = async () => {
    setBusy(true);
    const done = [];
    for (const id of sel) { await assignSalon(id, to).then(() => done.push(id)).catch(() => {}); } // eslint-disable-line no-await-in-loop
    setBusy(false);
    toast[done.length === sel.length ? "success" : "error"](`${done.length} din ${sel.length} saloane mutate la ${to ? nm(agents.find((a) => a.share_slug === to) || {}) : "fără agent"}`);
    setRows((l) => l.filter((r) => !done.includes(r.id)));
    setSel((s) => s.filter((id) => !done.includes(id)));
    window.dispatchEvent(new Event("bf-unassigned-refresh"));
    window.dispatchEvent(new Event("bf-moves-refresh"));
  };
  const opts = (skip) => [<option key="-" value="">Fără agent</option>, ...agents.filter((a) => a.share_slug !== skip).map((a) => <option key={a.share_slug} value={a.share_slug}>{nm(a)}</option>)];
  return (
    <section className="invite-box bf-smove" data-testid="bf-salon-move">
      <h3>Mută saloane de la un agent la altul</h3>
      <div className="bf-smove-bar">
        <label className="st-field"><span className="st-label">De la</span><select value={from} onChange={(e) => setFrom(e.target.value)} data-testid="bf-smove-from">{opts()}</select></label>
        <ArrowRight size={18} />
        <label className="st-field"><span className="st-label">La</span><select value={to} onChange={(e) => setTo(e.target.value)} data-testid="bf-smove-to">{opts(from)}</select></label>
        <button type="button" className="st-btn st-btn--silver" disabled={!sel.length || to === from || busy} onClick={move} data-testid="bf-smove-go">{busy ? <Loader2 size={14} className="animate-spin" /> : <ArrowRight size={14} />} Mută {sel.length || ""} {sel.length === 1 ? "salon" : "saloane"}</button>
      </div>
      {!rows ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : (
        <>
          <div className="bf-smove-tools">
            <input className="bf-smove-q" value={q} onChange={(e) => setQ(e.target.value)} placeholder={`Caută în cele ${rows.length} saloane`} data-testid="bf-smove-search" />
            <button type="button" className="bf-gate-switch" disabled={!shown.length} onClick={() => setSel(allOn ? sel.filter((id) => !shown.some((r) => r.id === id)) : [...new Set([...sel, ...shown.map((r) => r.id)])])} data-testid="bf-smove-all">{allOn ? "Deselectează tot" : "Selectează toate"}</button>
          </div>
          {!rows.length && <p className="st-hint" data-testid="bf-smove-empty">Niciun salon la acest agent.</p>}
          <ul className="bf-smove-list">
            {shown.map((r) => (
              <li key={r.id}><button type="button" className={sel.includes(r.id) ? "is-on" : ""} onClick={() => toggle(r.id)} aria-pressed={sel.includes(r.id)} data-testid={`bf-smove-row-${r.id}`}>
                <i>{sel.includes(r.id) && <Check size={13} />}</i><b>{r.salon || "Salon"}</b><small>{[r.admin_name, r.city, r.phone].filter(Boolean).join(" · ")}</small>
              </button></li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
